import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-attachment-viewer',
  templateUrl: './attachment-viewer.component.html',
  styleUrl: './attachment-viewer.component.scss'
})
export class AttachmentViewerComponent {
  
  // #region Variables
  @Input() attachmentsLength = 0;
  @Input() images: any[] = [];
  @Input() responsiveOptions: any[] = [];
  @Input() emptyMessage = '';
  @Input() buttonLabel = '';
  @Input() buttonIcon = '';
  @Input() showUpload = true;

  @Output() fileSelect = new EventEmitter<any>();
}
